import styled from 'styled-components';
import { BoxProps } from 'types';
import { BoxStyles } from 'components/Box/styles';

export const Page = styled.main<BoxProps>`
	${BoxStyles}
`;
